// extracted by mini-css-extract-plugin
export default {"field":"style_field__d8EMs","is3d":"style_is3d__KSv-P","gameOver":"style_gameOver__BbD0b"};